<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="/accounting/billing/receivable">
                    <icon name="list-alt"></icon>
                    รายละเอียดลูกหนี้
                </b-nav-item>&nbsp
                <b-nav-item router-link to="/accounting/billing/billings" v-if="canSaleOrdersAllView">
                    <icon name="file-invoice"></icon>
                    ใบวางบิล
                </b-nav-item>&nbsp
                <!--<b-nav-item router-link to="/accounting/billing/payments">-->
                    <!--<icon name="file-import"></icon>-->
                    <!--บันทึกรับ-->
                <!--</b-nav-item>&nbsp-->
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    import {
        canSaleView,
        canSaleOrdersAllView,
    } from "../../util/Permissions";
export default {
    name: "accounting-billing-layout",
    computed:{
        canSaleOrdersAllView,
    }
};
</script>

<style lang="scss" scoped></style>
